import React from 'react';
import { ScanLine, UserRound } from 'lucide-react';

const TABS = [
  ['scan', 'Scan', ScanLine],
  ['you', 'You', UserRound],
];

export function PrimaryTabBar({ activeTab, onChange }) {
  return (
    <nav
      className="w-full border-t border-slate-100 px-3 py-2"
      aria-label="Primary"
    >
      <div className="mx-auto grid max-w-md grid-cols-2 gap-2">
        {TABS.map(([id, label, Icon]) => {
          const active = activeTab === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onChange(id)}
              className={`flex min-h-11 items-center justify-center gap-2 rounded-2xl px-4 text-sm font-semibold transition-colors ${
                active
                  ? 'bg-emerald-100 text-emerald-800'
                  : 'text-slate-500 hover:bg-slate-100 hover:text-slate-800'
              }`}
              aria-current={active ? 'page' : undefined}
            >
              <Icon className="h-5 w-5" />
              {label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
